import React from "react";

export default function MonitoringSparkline({
	values,
	color = "#4F46E5",
	width = 96,
	height = 36,
	showFill = true,
	showEndDot = true,
}) {
	if (!values?.length) return null;

	const padX = showEndDot ? 3 : 0;
	const padY = 3;
	const max = Math.max(...values);
	const min = Math.min(...values);
	const range = max - min || 1;
	const innerW = width - padX * 2;
	const innerH = height - padY * 2;

	const coords = values.map((v, i) => {
		const x = padX + (values.length === 1 ? innerW / 2 : (i / (values.length - 1)) * innerW);
		const y = padY + (innerH - ((v - min) / range) * innerH);
		return { x, y };
	});

	const last = coords[coords.length - 1];
	const linePoints = coords.map((p) => `${p.x},${p.y}`).join(" ");
	const areaPath = [
		`M ${coords[0].x},${height - 1}`,
		...coords.map((p) => `L ${p.x},${p.y}`),
		`L ${last.x},${height - 1}`,
		"Z",
	].join(" ");

	return (
		<svg
			className="monitoring__sparkline"
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			aria-hidden="true"
		>
			{showFill && (
				<path d={areaPath} fill={color} fillOpacity={0.14} stroke="none" />
			)}
			<polyline
				fill="none"
				stroke={color}
				strokeWidth="2"
				strokeLinejoin="round"
				strokeLinecap="round"
				points={linePoints}
			/>
			{showEndDot && (
				<circle cx={last.x} cy={last.y} r={3} fill={color} stroke="#fff" strokeWidth="1" />
			)}
		</svg>
	);
}
